import { Fragment, memo, useContext } from 'react';
import PropTypes from 'prop-types';

import { FormDrawer } from '@sdflc/ui';

import { AppToolbar } from 'components/AppToolbar';
import { Block } from 'components/Block';

import { LocalizationContext } from '../../../contexts';

import { UserLocationList } from './UserLocationList';
import { useUserLocations } from './useUserLocations';

const UserLocations = memo((props) => {
  const { hasTitle } = props;
  const { getText } = useContext(LocalizationContext);
  const {
    open,
    userLocations,
    userLocationList,
    formData,
    formCfg,
    formActions,
    handleClickAction,
    handleClickClose,
    userLocationsOpsManager,
    actionInProgress,
    toolBarItems,
    saveOpResult,
    removingOps,
  } = useUserLocations();

  return (
    <Fragment>
      <Block title={hasTitle ? getText('pages.userLocations.title') : ''}>
        <AppToolbar items={toolBarItems} onClick={handleClickAction} />
        <UserLocationList
          onClickAction={handleClickAction}
          list={userLocationList}
          items={userLocations}
          listOp={userLocationsOpsManager.getListOp()}
          removingOps={removingOps}
        />
      </Block>
      <FormDrawer
        isOpen={open}
        title={getText('pages.userLocations.form.title.add')}
        description=''
        formData={formData}
        formCfg={formCfg}
        onClose={handleClickClose}
        actions={formActions}
        actionInProgress={actionInProgress}
        onClickAction={handleClickAction}
        progress={saveOpResult.isInProgress()}
        opResult={saveOpResult}
      />
    </Fragment>
  );
});

UserLocations.displayName = 'UserLocations';

UserLocations.propTypes = {
  children: PropTypes.node,
  hasTitle: PropTypes.bool,
};

UserLocations.defaultProps = {
  hasTitle: false,
};

export { UserLocations };
